<template>
  <div class="mains">
    <div class="shouye">首页</div>
    <div :model="list">
      <div class="shuliang">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="digong">
                <img src="@/assets/img/home-manage/yuangong.png" alt />
                <div class="yuangong">
                  <span>员工总数</span>
                  <span class="shuju">{{ list.curEmpNum }}</span>
                </div>
                <div class="xinzeng">
                  <span>管理员额度</span>
                  <span class="shuju">{{ list.incStudentNum }}</span>
                </div>
              </div>
              <div class="zengzhang">
                <span>较上月增长</span>
                <span :class="list.empNumRateInc ? 'green' : 'red'">{{ list.empPercent }}%</span>
                <span>
                  <img :src="src.icon" alt />
                </span>
                <span :class="list.empNumRateInc ? 'green' : 'red'" style="margin-left: 1vw">{{ list.incEmpNum }} 人</span>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="digong">
                <img src="@/assets/img/home-manage/xueyuan.png" alt />
                <div class="yuangong">
                  <span>学员总数</span>
                  <span class="shuju">{{ list.curStudentNum }}</span>
                </div>
                <!--<div class="xinzeng">
                  <span>本月新增</span>
                  <span class="shuju">{{list.incStudentNum}}</span>
                </div>  style="left: 14.5vw;"-->
                <div class="xinzeng">
                  <span>学员额度</span>
                  <span class="shuju">{{ list.incStudentNum }}</span>
                </div>
              </div>
              <div class="zengzhang">
                <span>较上月增长</span>
                <span :class="list.studentNumRateInc ? 'green' : 'red'">{{ list.studentPercent }}%</span>
                <span>
                  <img :src="src.icons" alt />
                </span>
                <span :class="list.studentNumRateInc ? 'green' : 'red'" style="margin-left: 1vw">{{ list.incStudentNum }} 人</span>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="digong">
                <img src="@/assets/img/home-manage/baoming.png" alt />
                <div class="yuangong">
                  <span>报名总数</span>
                  <span class="shuju">{{ list.curStudentUseNum }}</span>
                </div>
                <div class="xinzeng">
                  <span>本月报名</span>
                  <span class="shuju">{{ list.incStudentUseNum }}</span>
                </div>
              </div>
              <div class="zengzhang">
                <span>较上月增长</span>
                <span :class="list.studentUseNumRateInc ? 'green' : 'red'">{{ list.studentUsePercent }}%</span>
                <span>
                  <img :src="src.iconss" alt />
                </span>
                <span :class="list.studentUseNumRateInc ? 'green' : 'red'" style="margin-left: 1vw">{{ list.incStudentUseNum }} 人</span>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="digong">
                <img src="@/assets/img/home-manage/banji.png" alt />
                <div class="yuangong">
                  <span>班级总数</span>
                  <span class="shuju">{{ list.curClassNum }}</span>
                </div>
                <div class="xinzeng">
                  <span>新增班级</span>
                  <span class="shuju">{{ list.incClassNum }}</span>
                </div>
              </div>
              <div class="zengzhang">
                <span>较上月增长</span>
                <span :class="list.classNumRateInc ? 'green' : 'red'">{{ list.classPercent }}%</span>
                <span>
                  <img :src="src.iconsss" alt />
                </span>
                <span :class="list.classNumRateInc ? 'green' : 'red'" style="margin-left: 1vw">{{ list.incClassNum }} 人</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="echarts">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <div class>
                <div class="qushi">数据趋势</div>
                <div class="qiehuan">
                  <a href="#">
                    <span :class="this.qiehuan ? 'zhou' : ''" @click="qiehuan_1">本周</span>
                  </a>
                  <span style="margin: 0 1.1vw">|</span>
                  <a href="#">
                    <span :class="this.qiehuan ? '' : 'zhou'" @click="qiehuan_2">本月</span>
                  </a>
                </div>
                <div class="zengjia">
                  <img src="@/assets/img/home-manage/baomings.png" alt />
                  <span>本{{ huan }}新增学员</span>
                  <span style="left: 133px">较上{{ huan }}增长</span>
                </div>
              </div>
              <div id="echarts"></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="echarts">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <div class>
                <div class="qushi">互动趋势</div>
                <div class="qiehuan">
                  <a href="#">
                    <span :class="this.qiehuans ? 'zhou' : ''" @click="qiehuan_3">本周</span>
                  </a>
                  <span style="margin: 0 1.1vw">|</span>
                  <a href="#">
                    <span :class="this.qiehuans ? '' : 'zhou'" @click="qiehuan_4">本月</span>
                  </a>
                </div>
                <div class="zengjia">
                  <img src="@/assets/img/home-manage/baomingss.png" alt />
                  <span>本{{ huan1 }}互动次数</span>
                  <span style="left: 133px">较上{{ huan1 }}增长</span>
                </div>
              </div>
              <div id="echartss"></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <div class="jibenxinxi">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="jiben">基本信息</div>
              <div class="tupian">
                <img src="@/assets/img/home-manage/logo.png" alt />
              </div>
              <div>LOGO展示</div>
              <div class="app">APP名称：可为教育</div>
              <div>下载地址：https://app.51tyty.com/zkw5</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="jiben">用户端工具</div>
              <div class="tupian">
                <img src="@/assets/img/home-manage/yonghuduan.png" alt />
              </div>
              <div>扫码下载客户端</div>
              <div class="app">APP名称：可为教育</div>
              <div>下载地址：https://app.51tyty.com/zkw5</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="jiben">网站信息入口</div>
              <div class="tupian">
                <img src="@/assets/img/home-manage/wangzhan.png" alt />
              </div>
              <div>扫码打开手机网站</div>
              <div class="app">网站名：eltmax可为</div>
              <div>主页地址： https://em.51tyty.com/portal?c=zkw5</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="jiben">智能家校</div>
              <div class="tupian">
                <img src="@/assets/img/home-manage/jzt.png" alt />
              </div>
              <div>扫码进入小程序</div>
              <div class="app">APP名称：可为教育</div>
              <div>下载地址：https://app.51tyty.com/zkw5</div>
            </div>
          </el-col>
        </el-row>
      </div> -->
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  name: 'welcome',
  data() {
    return {
      src: {
        icon: '',
        icons: '',
        iconss: '',
        iconsss: '',
      },
      huan: '周',
      huan1: '周',
      list: [],
      lists: [],
      aListall: [],
      aListalls: [],
      qiehuan: false,
      qiehuans: false,
    };
  },
  mounted() {},
  watch: {
    qiehuan(newValue, oldValue) {
      if (newValue === true) {
        this.aListall = this.list.newStudentWeekList;
        this.huan = '周';
        this.echarts();
      } else {
        this.aListall = this.list.newStudentMonthList;
        this.huan = '月';
        this.echarts();
      }
    },
    qiehuans(newValue, oldValue) {
      if (newValue === true) {
        this.aListalls = this.list.studentActiveWeekList;
        this.huan1 = '周';
        this.echarts();
      } else {
        this.aListalls = this.list.studentActiveMonthList;
        this.huan1 = '月';
        this.echarts();
      }
    },
  },
  created() {
    // this.getArticleList();
  },
  methods: {
    getArticleList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // let orgid = this.$store.state.ids
      let pro = this.$http({
        url: '/stat/home/queryHomeData',
        method: 'POST',
        data: { orgid: orgid },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.list = result.data.data;
          // console.log(this.list)
          this.xinzeng();
          if (this.qiehuan === false) {
            this.aListall = this.list.newStudentMonthList;
          }
          if (this.qiehuans === false) {
            this.aListalls = this.list.studentActiveMonthList;
          }
          this.echarts();
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('获得首页数据失败：' + err);
        });
    },
    echarts() {
      var oChart = echarts.init(document.getElementById('echarts'));
      var oCharts = echarts.init(document.getElementById('echartss'));
      //   { count: 3, date: '2020-04-13' },
      let aCount = [];
      let aDate = [];
      // console.log(this.aListalls)
      if (this.aListall.length > 0) {
        for (var i = 0; i < this.aListall.length; i++) {
          aCount.push(this.aListall[i].new_student_num);
          aDate.push(this.aListall[i].stat_time);
        }
      } else {
        this.$message.error('没有符合条件的数据!');
      }
      var chartopt = {
        title: {
          // text: '月新增文章数',
          left: 'center',
          top: '10',
        },
        tooltip: {
          trigger: 'axis',
          extraCssText: 'color:#fff;background:#00A6E6;',
          formatter(params) {
            // console.log(params[0].data)
            return '<div style = "text-align:left">' + '<span style="font-size:8px;">' + params[0].name + '</span>' + '<br/>' + '<span style="font-size:0.5vw;">' + '新增学员' + ' : ' + params[0].data + '</span>' + '<span style="font-size:0.5vw;">' + '人' + '</span>' + '</div>';
          },
        },
        // 下载
        // toolbox: {
        //   show: true,
        //   feature: {
        //     saveAsImage: { show: true }
        //   }
        // },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     start: 30,
        //     end: 3
        //   },
        //   {
        //     type: 'inside'
        //   }
        // ],
        calculable: true,
        xAxis: [
          {
            // name: '日',
            type: 'category',
            // boundaryGap: false,
            data: aDate,
            axisTick: {
              alignWithLabel: true,
              inside: true,
              length: 8,
            },
            axisLine: {
              lineStyle: {
                color: '#707070FF',
                // width: 8,//这里是为了突出显示加上的
              },
            },
          },
        ],
        yAxis: [
          {
            // name: '月新增文章数',
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#707070FF',
                // width: 8,//这里是为了突出显示加上的
              },
            },
          },
        ],
        series: [
          {
            // name: '新增学员',
            type: 'line',
            // smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 4,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(0,148,206,0.6)',
                    },
                    {
                      offset: 0.8,
                      color: 'rgba(0,148,206,0)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(0,148,206,1)',
                borderColor: '#fff',
                borderWidth: 4,
              },
            },
            data: aCount,
            smooth: true,
          },
        ],
        grid: {
          show: true,
          borderWidth: '0',
          x: '4%',
          y: '5%',
          width: '92%',
          height: '85%',
        },
      };

      let aCounts = [];
      let aDates = [];
      if (this.aListalls.length > 0) {
        for (var j = 0; j < this.aListalls.length; j++) {
          aCounts.push(this.aListalls[j].checkin_num);
          aDates.push(this.aListalls[j].stat_time);
        }
      } else {
        this.$message.error('没有符合条件的数据!');
      }
      var chartopts = {
        title: {
          // text: '月新增文章数',
          left: 'center',
          top: '10',
        },
        tooltip: {
          trigger: 'axis',
          extraCssText: 'color:#fff;background:#00A6E6;',
          formatter(params) {
            // console.log(params[0].data)
            return '<div style = "text-align:left">' + '<span style="font-size:8px;">' + params[0].name + '</span>' + '<br/>' + '<span style="font-size:0.5vw;">' + '新增学员' + ' : ' + params[0].data + '</span>' + '人' + '</div>';
          },
        },
        // 下载
        // toolbox: {
        //   show: true,
        //   feature: {
        //     saveAsImage: { show: true }
        //   }
        // },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     start: 30,
        //     end: 3
        //   },
        //   {
        //     type: 'inside'
        //   }
        // ],
        calculable: true,
        xAxis: [
          {
            // name: '日',
            type: 'category',
            // boundaryGap: false,
            data: aDates,
            axisTick: {
              alignWithLabel: true,
              inside: true,
              length: 8,
            },
            axisLine: {
              lineStyle: {
                color: '#707070FF',
                // width: 8,//这里是为了突出显示加上的
              },
            },
          },
        ],
        yAxis: [
          {
            // name: '月新增文章数',
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#707070FF',
                // width: 8,//这里是为了突出显示加上的
              },
            },
          },
        ],
        series: [
          {
            // name: '新增文章',
            type: 'line',
            // smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 4,
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(0,148,206,0.6)',
                    },
                    {
                      offset: 0.8,
                      color: 'rgba(0,148,206,0)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(0,148,206,1)',
                borderColor: '#fff',
                borderWidth: 4,
              },
            },
            data: aCounts,
            smooth: true,
          },
        ],
        grid: {
          show: true,
          borderWidth: '0',
          x: '4%',
          y: '5%',
          width: '92%',
          height: '85%',
        },
      };
      oChart.setOption(chartopt);
      oCharts.setOption(chartopts);
    },
    // xinzeng() {
    //   if (this.list.empNumRateInc === '1') {
    //     this.list.empNumRateInc = true;
    //     this.src.icon = require('@/assets/img/home-manage/zengchang.png');
    //   } else {
    //     this.list.empNumRateInc = false;
    //     this.src.icon = require('@/assets/img/home-manage/jianshao.png');
    //   }
    //   if (this.list.studentNumRateInc === '1') {
    //     this.list.studentNumRateInc = true;
    //     this.src.icons = require('@/assets/img/home-manage/zengchang.png');
    //   } else {
    //     this.list.studentNumRateInc = false;
    //     this.src.icons = require('@/assets/img/home-manage/jianshao.png');
    //   }
    //   if (this.list.studentUseNumRateInc === '1') {
    //     this.list.studentUseNumRateInc = true;
    //     this.src.iconss = require('@/assets/img/home-manage/zengchang.png');
    //   } else {
    //     this.list.studentUseNumRateInc = false;
    //     this.src.iconss = require('@/assets/img/home-manage/jianshao.png');
    //   }
    //   if (this.list.classNumRateInc === '1') {
    //     this.list.classNumRateInc = true;
    //     this.src.iconsss = require('@/assets/img/home-manage/zengchang.png');
    //   } else {
    //     this.list.classNumRateInc = false;
    //     this.src.iconsss = require('@/assets/img/home-manage/jianshao.png');
    //   }
    // },
    qiehuan_1() {
      this.qiehuan = true;
    },
    qiehuan_2() {
      this.qiehuan = false;
    },
    qiehuan_3() {
      this.qiehuans = true;
    },
    qiehuan_4() {
      this.qiehuans = false;
    },
  },
};
</script>

<style lang="less">
.mains {
  .shouye {
    width: 1.5vw;
    height: 1vw;
    font-family: PingFang SC;
    font-size: 0.73vw;
    color: #666666ff;
    font-weight: 400;
    line-height: 1vw;
    margin-bottom: 0.5vw;
  }
  .shuliang {
    .el-row {
      margin-bottom: 1vw;
      &:last-child {
        margin-bottom: 0;
      }
      .grid-content {
        border-radius: 8px;
        height: 7.27vw;
        background: #fff;
        .digong {
          width: 86%;
          border-bottom: 1px solid rgba(153, 153, 153, 0.6);
          margin: 0 auto;
          position: relative;
          // padding-left: 1.3vw;
          img {
            // margin: 7px 0 0 7px;
            height: 4.05vw;
            margin-top: 1.05vw;
          }
          .yuangong {
            position: absolute;
            top: 1.5vw;
            left: 6vw;
            span {
              display: block;
              font-size: 0.73vw;
              color: #999;
            }
            .shuju {
              font-size: 1.4vw;
              font-family: PingFang SC;
              font-weight: bold;
              color: rgba(51, 51, 51, 1);
              letter-spacing: 2px;
              margin-top: 0.2vw;
            }
          }
          .xinzeng {
            position: absolute;
            top: 1.5vw;
            left: 10.5vw;
            span {
              display: block;
              font-size: 0.73vw;
              color: #999;
            }
            .shuju {
              font-size: 1.4vw;
              font-family: PingFang SC;
              font-weight: bold;
              color: rgba(51, 51, 51, 1);
              letter-spacing: 2px;
              margin-top: 0.2vw;
            }
          }
        }
        .zengzhang {
          font-size: 0.68vw;
          color: #999;
          margin: 0.5vw 0 0 1.5vw;
          .green {
            color: #03c022ff;
            margin: 0 8px 0 0.5vw;
          }
          .red {
            color: #e00909ff;
            margin: 0 8px 0 0.5vw;
          }
        }
      }
      .row-bg {
        padding: 0.5vw 0;
        background-color: #f9fafc;
      }
    }
  }
  .echarts {
    .el-row {
      margin: 1vw 0;
      background: #fff;
      border-radius: 8px;
      .grid-content {
        width: 100%;
        height: 100%;
        .qushi {
          font-size: 0.85vw;
          color: #333;
          border-left: 3px solid #0090c9ff;
          line-height: 0.94vw;
          padding-left: 0.5vw;
          margin: 1.3vw 0 0 1.3vw;
          font-weight: bold;
        }
        .qiehuan {
          font-size: 0.94vw;
          float: right;
          color: #999;
          margin-right: 3vw;
          font-weight: bold;
          .zhou {
            color: #0094ceff;
          }
          a {
            text-decoration: none;
            color: #999;
          }
        }
        .zengjia {
          font-size: 0.73vw;
          color: #666;
          position: relative;
          margin: 1vw 0 0 2vw;
          span {
            margin: auto;
            position: absolute;
            top: 12px;
          }
        }
        #echarts {
          width: 100%;
          height: 26vw;
        }
        #echartss {
          width: 100%;
          height: 26vw;
        }
      }
    }
  }
  .jibenxinxi {
    .el-row {
      margin-bottom: 1vw;
      &:last-child {
        margin-bottom: 0;
      }
      .grid-content {
        border-radius: 8px;
        height: 21vw;
        background: #fff;
        font-size: 0.73vw;
        color: #333;
        font-weight: bold;
        text-align: center;
        .jiben {
          font-size: 0.85vw;
          border-left: 3px solid #0090c9ff;
          line-height: 0.94vw;
          padding-left: 0.5vw;
          position: relative;
          top: 1.3vw;
          // left: 1.3vw;
          margin-left: 1.3vw;
          text-align: left;
        }
        .tupian {
          width: 10.9vw;
          height: 10.9vw;
          margin: 2.6vw auto 0.5vw auto;
          img {
            height: 9.35vw;
          }
        }
        .app {
          margin-top: 1.4vw;
        }
      }
    }
  }
}
</style>
